<template>
  <div class="relative">
    <div v-if="tooltip" :class="`${tooltipPosition} absolute top-1 z-10`"><Tooltip :heading="tooltip.heading" :text="tooltip.text" /></div>
    <div>
      <snap-select-menu
        :id="id"
        :placeholder="placeholder"
        :help-text="helpText"
        :label="label"
        :multi="false"
        :modal-type="modalType"
        :search="isSearchable"
        :modal-title="modalTitle"
        :selectMenuOptions="menuOptions"
        :error="errorMessage.length"
        search-method="contain"
        @snap-select-menu-updated="selectOption($event)"
      >
      </snap-select-menu>
      <span v-if="errorMessage.length" class="font-inter text-sm text-red-500 font-normal mt-2">{{ errorMessage }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
// Imports
import { onMounted, defineProps, ref, watch, PropType } from "vue";
import { IOption } from "@/interfaces/SupportInterfaces";
import { ITooltip } from "@/interfaces/CommonInterfaces";
import Tooltip from "./Tooltip.vue";

// Props
const props = defineProps({
  id: {
    type: String,
    default: "snap-select-menu",
  },
  placeholder: {
    type: String,
    default: "Select An Option",
  },
  helpText: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  modalTitle: {
    type: String,
    default: "Select An Option",
  },
  isSearchable: {
    type: Boolean,
    default: false,
  },
  modalType: {
    type: String,
    default: "drawer",
  },
  options: {
    type: Object as PropType<IOption[]>,
    default: null,
  },
  avatar: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  tooltip: {
    type: Object as PropType<ITooltip>,
    default: null,
  },
  tooltipPosition: {
    type: String,
    default: "right-0",
  },
});

// Emits
const emit = defineEmits(["onSelect"]);

// States
const menuOptions = ref<IOption[]>([]);

const setMenuOptions = () => {
  setTimeout(() => {
    if (props.options?.length) {
      menuOptions.value = [...props.options.map((option) => option)];
    }
  }, 500);
};
onMounted(() => setMenuOptions());
watch(
  () => ({ options: props.options }),
  () => setMenuOptions()
);
const selectOption = (ev: { detail: IOption[] }) => {
  emit("onSelect", ev.detail);
};
</script>
